import PageIhrTier from './step-ihr-tier/Page';
import PageAngebot from './step-angebot/Page';
import PageAntrag from './step-antrag/Page';
import PageEingereicht from './step-eingereicht/Page';
import GtmPageviewTitle from '../../../gtm/types/GtmPageviewTitleId';

export default class WizardStepContent {
    static maxStepCount = 4;

    static P_IHR_TIER = new WizardStepContent(0, "IHR_TIER", <PageIhrTier />, 0, GtmPageviewTitle.PAGE_IHR_TIER);
    static P_ANGEBOT = new WizardStepContent(1, "ANGEBOT", <PageAngebot />, 0, GtmPageviewTitle.PAGE_ANGEBOT);
    static P_ANTRAG = new WizardStepContent(2, "ANTRAG", <PageAntrag />, 100, GtmPageviewTitle.PAGE_ANTRAG);
    static P_EINGEREICHT = new WizardStepContent(3, "EINGEREICHT", <PageEingereicht />, 0, GtmPageviewTitle.PAGE_EINGEREICHT);

    readonly name: string;

    readonly content: JSX.Element;

    readonly stepIndex: number;

    readonly marginTopMobile: number;

    readonly gtmDataLayerValue: GtmPageviewTitle;

    constructor(newStepIndex: number, newName: string, newContent: JSX.Element, newMarginTopMobile: number, newGtmDataLayerValue: GtmPageviewTitle) {
        this.name = newName;
        this.content = newContent;
        this.stepIndex = newStepIndex;
        this.marginTopMobile = newMarginTopMobile;
        this.gtmDataLayerValue = newGtmDataLayerValue;
    }

    static getType = (step: number) => {
        switch (step) {
            case WizardStepContent.P_IHR_TIER.stepIndex:
                return WizardStepContent.P_IHR_TIER;

            case WizardStepContent.P_ANGEBOT.stepIndex:
                return WizardStepContent.P_ANGEBOT;

            case WizardStepContent.P_ANTRAG.stepIndex:
                return WizardStepContent.P_ANTRAG;

            case WizardStepContent.P_EINGEREICHT.stepIndex:
                return WizardStepContent.P_EINGEREICHT

            default:
                throw new Error('Unknown step');
        }
    };
}